<template>


  <div class="content content-fixed content-auth-alt">
    <div class="container ht-100p tx-center">

      <div class="ht-100p d-flex flex-column align-items-center justify-content-center">
        <div class="wd-70p wd-sm-250 wd-lg-300 mg-b-15"><img
            src="http://themepixels.me/demo/dashforge2/assets/img/img19.png" class="img-fluid" alt="">
        </div>

        <div v-if="activationSuccess">
          <h1 class="tx-color-01 tx-24 tx-sm-32 tx-lg-36 mg-xl-b-5"> Success </h1>
          <h5 class="tx-16 tx-sm-18 tx-lg-20 tx-normal mg-b-20">Your account has been successfully activated please
            click the link below to login</h5>
          <div class="mg-b-40">
            <router-link to="/login" class="btn btn-white pd-x-30">Click to Login</router-link>
          </div>
        </div>

        <div v-else>
          <h1 class="tx-color-01 tx-24 tx-sm-32 tx-lg-36 mg-xl-b-5"> Oops! {{ code }} {{ message }} You Have Not
            Confirmed your email </h1>
          <h5 class="tx-16 tx-sm-18 tx-lg-20 tx-normal mg-b-20"> A confirmation mail with instructions has been sent to
            your email address.</h5>
          <p class="tx-color-03 mg-b-30"> Follow those instructions to confirm your email address and
            activate your account. </p>

          <div class="mg-b-40">
            <router-link to="/login" class="btn btn-white pd-x-30">Back to Login</router-link>
          </div>
          <span class="tx-12 tx-color-03">Error page concept with laptop vector is created by
            <a href="#" v-on:click="resendActivationCode"> Resend Activation Verification </a></span>

          <div v-if="activationFailed" class="alert alert-outline alert-danger d-flex align-items-center" role="alert">
            {{ activationFailed }}
          </div>
        </div>


      </div>


    </div><!-- container -->
  </div><!-- content -->

  <AuthFooter/>


</template>

<script>
import AuthFooter from "./AuthFooter.vue";

export default {
  name: "AccountActivation",
  components: {AuthFooter},
  data() {
    return {
      activationFailed: null,
      activationSuccess: null,
    };
  },
  props: {
    token: {
      type: String,
    },
    mode: {
      type: String,
    },
  },
  methods: {
    async resendActivationCode() {
      //   try {
      //     let result = await axios.post(
      //       `${this.authServer}/reset-password`,
      //       this.resetDto
      //     );
      //     if (result.status == 200) {
      //       this.passwordResetSuccess = true;
      //     }
      //   } catch (error) {
      //     if (error.response) {
      //       alert(JSON.stringify(error.response.data));
      //     }
      //   }
    },
    async activateAccount() {
      let data = {
        token: this.token,
        mode: this.mode,
      };
      console.log(data);
      try {
        let result = await this.$axios.put(`${this.authServer}/account-activation`, data);
        if (result.status === 200) {
          this.activationSuccess = true;
        }
      } catch (error) {
        if (error.response) {
          console.log(error.response.data)
          this.activationFailed = error.response.data.errorMessage;
        }
      }
    },
  },
  mounted() {
    if (this.token) {
      this.activateAccount();
    } else {
      console.log("this needs to check mail");
    }
  },
};
</script>
